import { useHttpClient } from './httpClient.js';

const resource = 'homepage';

export function fetchChannelName() {
	return useHttpClient().get(`/${resource}/stream_channel`);
}

export function fetchStyleConfiguration() {
	return useHttpClient().get(`/${resource}/style`);
}

export function fetchNextSortition() {
	return useHttpClient().get(`/${resource}/sortition`);
}

export function fetchDisplaySortitions() {
	return useHttpClient().get(`/${resource}/display-sortitions`);
}

export function fetchDisplaySortition(id) {
	return useHttpClient().get(`/${resource}/display-sortition/${id}`);
}

export function requestFetchDisplayResults(sortitionId) {
	return useHttpClient().get(`/${resource}/fetch-display-results`, {
		params: { sortitionId }
	});
}

export function fetchPrizes() {
	return useHttpClient().get(`/${resource}/prizes`);
}

export function fetchResults() {
	return useHttpClient().get(`/${resource}/results`);
}

export function fetchCardResults() {
	return useHttpClient().get(`/${resource}/card-results`);
}

export function fetchSortitionResult(sortitionId) {
	return useHttpClient().get(`/${resource}/sortition/${sortitionId}/result`);
}

export function fetchHistoricalResults() {
	return useHttpClient().get(`/${resource}/historical_results`);
}
